export const TABLE_FILTER_TYPES = ['assets', 'inspectors'];

export const TABLE_FILTER_CONFIG = {
  assets: {
    id: 'assets',
    queryKey: 'assetIds',
    groupLabelKey: 'evirPx_Assets',
    fallbackGroupLabel: 'Assets',
    getId: (item) => item?.id || null,
    getPrimaryLabel: (item) => item?.label || '',
  },
  inspectors: {
    id: 'inspectors',
    queryKey: 'inspectorIds',
    groupLabelKey: 'evirPx_Inspectors',
    fallbackGroupLabel: 'Inspectors',
    getId: (item) => item?.id || null,
    getPrimaryLabel: (item) => item?.title || '',
  },
  tags: {
    id: 'tags',
    queryKey: 'assetTagIds',
    groupLabelKey: 'evirPx_Tags',
    fallbackGroupLabel: 'Tags',
    getId: (item) => item?.id ? String(item.id) : null,
    getPrimaryLabel: (item) => item?.label || '',
    showFromStart: true,
    useLocalFilter: true,
  },
};

export const TABLE_FILTER_QUERY_KEYS = TABLE_FILTER_TYPES.map(
  (type) => TABLE_FILTER_CONFIG[type].queryKey,
);
